var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    {
      staticClass: "watchlater be-outer-watchlater video-toolbar-left-item",
      class: { on: _vm.on, ..._vm.displayModeClass },
      attrs: { title: "稍后再看" },
      on: {
        click: function ($event) {
          return _vm.toggle()
        },
      },
    },
    [
      _c("VIcon", {
        staticClass: "icon",
        attrs: { size: 28, icon: "mdi-timetable" },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [_vm._v("稍后再看")]),
      _vm._v(" "),
      _c("div", { staticClass: "tip", class: { show: _vm.tipShowing } }, [
        _vm._v(_vm._s(_vm.tipText)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }